//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import {
  InstagramBusinessAccountMessageAccessStatus,
  InstagramMessageAccessStatusAccountDetails,
} from '@apis/instagram-settings/gatewayInstagramSettingsApiModel';
import { partition } from '@utils/arrayUtils';

export const partitionAccountsByMessagesAccessStatus = (
  instagramAccountMessagesAccessStatus: InstagramBusinessAccountMessageAccessStatus[],
) => {
  const [accountsWithAccess, accountsWithoutAccess] = partition(
    (account) => account.isMessagesAccessEnabled,
    instagramAccountMessagesAccessStatus,
  );

  return {
    accountsWithAccess: accountsWithAccess.map(
      (account) => account.accountDetails,
    ),
    accountsWithoutAccess: accountsWithoutAccess.map(
      (account) => account.accountDetails,
    ),
  };
};

/**
 * Returns a comma-separated string of account names, each prefixed with '@'.
 */
export const getAccountNames = (
  accountDetails: InstagramMessageAccessStatusAccountDetails[],
): string => {
  return accountDetails.map((account) => `@${account.username}`).join(', ');
};
